/** Keep an absolute dropdown inside the viewport and its clipping ancestors. */
export const getDropdownPosition = (anchor: HTMLElement, preferredWidth = 400) => {
  const viewport = window.visualViewport
  let left = viewport?.offsetLeft ?? 0
  let right = left + (viewport?.width ?? window.innerWidth)

  for (let parent = anchor.parentElement; parent; parent = parent.parentElement) {
    if (!/^(auto|scroll|hidden|clip|overlay)$/.test(getComputedStyle(parent).overflowX)) continue
    const rect = parent.getBoundingClientRect()
    left = Math.max(left, rect.left)
    right = Math.min(right, rect.right)
  }

  const padding = Math.min(8, Math.max(0, right - left) / 2)
  left += padding
  right -= padding
  const width = Math.min(preferredWidth, Math.max(0, right - left))
  const anchorLeft = anchor.getBoundingClientRect().left
  const dropdownLeft = Math.max(left, Math.min(anchorLeft, right - width))
  return { left: dropdownLeft - anchorLeft, width }
}
